import React, { useEffect, useState } from 'react';
const NAMES = ['David', 'James', 'Tom', 'Mark', 'Chris', 'Paul', 'Andy', 'Steve', 'Liam', 'Daniel', 'Owen', 'Harry', 'Jack', 'Sarah', 'Emma'];
const CITIES = ['Leicester 🇬🇧', 'Bath 🇬🇧', 'Gloucester 🇬🇧', 'Bristol 🇬🇧', 'Northampton 🇬🇧', 'Exeter 🇬🇧', 'Newcastle 🇬🇧', 'Cardiff 🇬🇧', 'Edinburgh 🇬🇧', 'Manchester 🇬🇧', 'London 🇬🇧', 'Worcester 🇬🇧'];
const PRODUCTS = [{
  name: 'Rugby Ready Megapack',
  emoji: '🏉'
}];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  product: {
    name: string;
    emoji: string;
  };
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2;
  return {
    name,
    initial,
    city,
    product,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    let initialTimeout: ReturnType<typeof setTimeout>;
    let idleHandle: number | null = null;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = 45000 + Math.floor(Math.random() * 30000);
        showTimeout = setTimeout(cycleNotification, nextDelay);
      }, 4000);
    };
    // PERF: Register the first-popup timer during idle time so it doesn't
    // compete with hydration / LCP paint. Falls back to setTimeout for
    // browsers without requestIdleCallback. User-visible timing is unchanged
    // (still ~30s after load), but the timer no longer queues on the
    // hot critical path.
    const scheduleFirst = () => {
      initialTimeout = setTimeout(cycleNotification, 30000);
    };
    const w = window as any;
    if (typeof w.requestIdleCallback === 'function') {
      idleHandle = w.requestIdleCallback(scheduleFirst, {
        timeout: 2000
      });
    } else {
      initialTimeout = setTimeout(scheduleFirst, 200);
    }
    return () => {
      if (idleHandle !== null && typeof w.cancelIdleCallback === 'function') {
        w.cancelIdleCallback(idleHandle);
      }
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed top-4 right-4 sm:top-6 sm:right-6 z-50 transition-[transform,opacity] duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-321">
      <div className="bg-bg-alt border border-border-light rounded-2xl shadow-xl p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-322">
        <button onClick={() => setIsDismissed(true)} className="absolute top-3 right-3 text-text-sec hover:text-white transition-colors p-1" aria-label="Dismiss notification" data-id="element-323">
          ✕
        </button>

        <div className="flex items-center gap-3 mb-3" data-id="element-324">
          <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 flex items-center justify-center shadow-inner" data-id="element-325">
            <span className="text-sm" data-id="element-326">👤</span>
          </div>
          <span className="text-text-main text-sm font-bold" data-id="element-327">
            {notification.name} {notification.initial}.{' '}
            <span className="text-text-sec font-normal ml-1 text-xs" data-id="element-328">
              from {notification.city}
            </span>
          </span>
        </div>

        <p className="text-text-main text-sm mb-2 leading-tight font-medium" data-id="element-329">
          Just purchased the{' '}
          <span className="text-primary font-bold" data-id="element-330">
            {notification.product.name}
          </span>{' '}
          {notification.product.emoji}
        </p>

        <div className="flex items-center gap-2 mt-3 pt-2 border-t border-border-light/50" data-id="element-331">
          <div className="w-2 h-2 bg-check-green rounded-full shadow-[0_0_8px_rgba(16,185,129,0.8)]" data-id="element-332"></div>
          <p className="text-text-sec text-[10px] font-bold uppercase tracking-wider" data-id="element-333">
            Verified purchase · {notification.timeAgo} min ago
          </p>
        </div>
      </div>
    </div>;
}